import { componentSizes } from '@bigin/constants'
import { buildProps } from '@bigin/utils'

import type { ExtractPropTypes } from 'vue'

export const formItemProps = buildProps({
  label: String,
  required: Boolean,
  optional: Boolean,
  error: {
    type: [String, Boolean],
    default: false,
  },
  helpText: String,
  value: {
    type: [String, Number, Boolean, Object],
    default: '',
  },
  size: {
    type: String,
    values: componentSizes,
  },
  topless: Boolean,
} as const)
export type FormItemProps = ExtractPropTypes<typeof formItemProps>
